import {get} from "./SimpleClient";

export const DownloadFile = async (name, url) => {
    try {
        const response = await get(url);
        if (!(response instanceof Blob) || response.size === 0) {
            console.error('Invalid file received:', name);
            return;
        }
        const blobUrl = window.URL.createObjectURL(response);
        const link = document.createElement('a');
        link.style.display = 'none';
        document.body.appendChild(link);

        link.href = blobUrl;
        link.download = name || 'file.pdf';
        link.click();

        window.URL.revokeObjectURL(blobUrl);

    } catch (error) {
        console.error('Download failed for', name, error);
    }
}